<section>
    <div class="container-fluid bg-cta">
        <div class="row pt-2 pb-2 pt-xl-5 pb-xl-5">
            <div class="col-xl-5 col-6 offset-md-1 offset-0 pt-xl-5 pb-xl-5 pt-3 pb-3">
                <h1 class="txt-cta">Still Confused About Your Career Choice? Consult With Our Experts</h1>
                <button class="btn btn-cta px-xl-4 py-xl-2 px-2 py-0 mt-xl-3 mt-1" type="button">Contact Us</button>
            </div>
        </div>
    </div>
</section>